import IconButton, { type IconButtonProps } from '@mui/material/IconButton';
import { stripBorders } from '../constants';

export interface IconStandardButtonProps extends IconButtonProps {
  noBorder?: boolean;
}

export const IconStandardButton = ({
  children,
  color = 'inherit',
  noBorder,
  sx,
  ...props
}: IconStandardButtonProps) => (
  <IconButton
    sx={{
      ...(noBorder ? stripBorders : {}),
      ...sx,
    }}
    color={color}
    {...props}
  >
    {children}
  </IconButton>
);

export default IconStandardButton;
